
import DashboardStatsCards from "@/components/admin/DashboardStatsCards";
import DashboardSearchBar from "@/components/admin/DashboardSearchBar";
import DashboardTabs from "@/components/admin/DashboardTabs";
import React from "react";
import type { Article } from "@/types/article";
import type { User } from "@/utils/adminMockData";

type Props = {
  articleCount: number;
  searchTerm: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  articles: Article[];
  filteredArticles: Article[];
  archivedArticles: Article[];
  filteredArchivedArticles: Article[];
  loadingArticles: boolean;
  deleteDialog: { open: boolean; article: Article | null };
  onView: (id: number | string) => void;
  onEdit: (id: number | string) => void;
  onOpenDelete: (article: Article) => void;
  onCloseDelete: () => void;
  onDelete: (id: number | string) => void;
  onArchive: (id: number | string) => void;
  onUnarchive: (id: number | string) => void;
  filteredUsers: User[];
};

const AdminDashboardContent: React.FC<Props> = ({
  articleCount,
  searchTerm,
  onSearch,
  articles,
  filteredArticles,
  archivedArticles,
  filteredArchivedArticles,
  loadingArticles,
  deleteDialog,
  onView,
  onEdit,
  onOpenDelete,
  onCloseDelete,
  onDelete,
  onArchive,
  onUnarchive,
  filteredUsers,
}) => (
  <>
    <DashboardStatsCards articleCount={articleCount} />
    <DashboardSearchBar value={searchTerm} onChange={onSearch} />
    <DashboardTabs
      articles={articles}
      filteredArticles={filteredArticles}
      archivedArticles={archivedArticles}
      filteredArchivedArticles={filteredArchivedArticles}
      loadingArticles={loadingArticles}
      deleteDialog={deleteDialog}
      onView={onView}
      onEdit={onEdit}
      onOpenDelete={onOpenDelete}
      onCloseDelete={onCloseDelete}
      onDelete={onDelete}
      onArchive={onArchive}
      onUnarchive={onUnarchive}
      searchTerm={searchTerm}
      onSearch={onSearch}
      filteredUsers={filteredUsers}
    />
  </>
);

export default AdminDashboardContent;
